import { DragDropModule } from '@angular/cdk/drag-drop';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  computed,
  inject,
} from '@angular/core';
import { MatOptionModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Resolution } from '@api-types/enums/resolution.enum';
import { NgxVirtualSelectFieldModule } from '@components/base-elements/virtual-select-field';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { ResolutionService } from 'demand-forecasting/services/resolution.service';
import { ConfigurationsSelectors } from 'demand-forecasting/store/configurations/configurations.selectors';

@Component({
  selector: 'pm-resolution-picker',
  template: `
    <mat-form-field
      class="w-full"
      appearance="outline"
      subscriptSizing="dynamic"
    >
      <mat-label>
        {{ 'RESULT.SIDEBAR.RESOLUTION.TITLE' | translate }}
      </mat-label>
      <ngx-virtual-select-field
        appearance="outline"
        [value]="resolution"
        [multiple]="false"
        (valueChange)="changeResolution($event)"
      >
        <ngx-virtual-select-field-option
          *ngxVirtualSelectFieldOptionFor="
            let resolution of this.availableResolutions()
          "
          [value]="resolution.value"
        >
          {{ resolution.label }}
        </ngx-virtual-select-field-option>
      </ngx-virtual-select-field>
    </mat-form-field>
  `,
  imports: [
    DragDropModule,
    MatSelectModule,
    MatOptionModule,
    MatDividerModule,
    MatFormFieldModule,
    TranslateModule,
    NgxVirtualSelectFieldModule,
  ],
})
export class ResolutionPickerComponent {
  @Input() resolution: Resolution | undefined;
  @Output() resolutionChange = new EventEmitter<Resolution>();

  private readonly store = inject(Store);
  private readonly resolutionService = inject(ResolutionService);
  private readonly configuration = this.store.selectSignal(
    ConfigurationsSelectors.selectConfigurationByUrlParam,
  );

  protected availableResolutions = computed(() => {
    const configuration = this.configuration();
    if (configuration) {
      return this.resolutionService.getResolutionOptionsByConfiguration(
        configuration,
      );
    }
    return [];
  });

  changeResolution(
    resolution: Resolution | (Resolution | undefined)[] | undefined,
  ) {
    if (!resolution) {
      return;
    }
    if (Array.isArray(resolution)) {
      return;
    }

    this.resolutionChange.emit(resolution);
  }
}
